"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TERMS_OF_SERVICE_URL = exports.PRIVACY_POLICY_URL = exports.ENVIRONMENT = exports.CONSENT_KEY = exports.CONSENT_DISPLAY_TEXT = void 0;
var ENVIRONMENT = exports.ENVIRONMENT = /*#__PURE__*/function (ENVIRONMENT) {
  ENVIRONMENT["LOCAL"] = "local";
  ENVIRONMENT["DEV"] = "development";
  ENVIRONMENT["STAGING"] = "staging";
  ENVIRONMENT["PROD"] = "production";
  return ENVIRONMENT;
}({});
var CONSENT_KEY = exports.CONSENT_KEY = {
  COMMUNITY: 'communityTermsOfService',
  PRIVACY: 'privacyPolicy'
};
var TERMS_OF_SERVICE_URL = exports.TERMS_OF_SERVICE_URL = 'https://www.atlassian.com/legal/training-terms-and-policies';
var PRIVACY_POLICY_URL = exports.PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
var CONSENT_DISPLAY_TEXT = exports.CONSENT_DISPLAY_TEXT = {
  VERSION_1: {
    key: 'VERSION_1',
    text: "By continuing, you accept the <a href='https://www.atlassian.com/legal/training-terms-and-policies' target=\"_blank\"> Community Terms of Use </a> and acknowledge the <a href='https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers' target=\"_blank\"> Privacy Policy </a>. Your public name, photo, and achievements may be publicly visible and available in search engines."
  }
};